<!--
 * @Description: 功能描述
 * @Version: 1.0
 * @Author: Yuchuan
 * @Date: 2022-01-21 08:42:08
-->
<template>
  <section class="member-enterprises-container">
    <div class="member-enterprises-container--inner">
      <div class="sec-title-container">
        <div class="sec-title-zh">成员企业</div>
        <div class="sec-title-en">MEMBER ENTERPRISES</div>
      </div>
      <div class="member-enterprises-content">
        <template v-for="(item, index) in listData">
          <div class="member-item" :class="item.class" :key="index">
            <div class="member-item-container">
              <div class="member-item-image-container">
                <img :src="item.imgSrc" alt="" />
              </div>
              <div class="member-item-content">
                <div class="member-item-title">{{ item.title }}</div>
                <div class="member-item-text">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </template>
        <div class="memeber-more" v-show="nowSizeChange()">
          <div class="member-more-content">
            <div class="member-more-icon">
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div class="memeber-more-font">更多企业</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      listData: [
        {
          imgSrc: '/static/images/logo-uxun.png',
          class: 'member-uxun',
          title: '深圳市优讯信息技术有限公司',
          desc: '银行金融IT服务',
        },
        {
          imgSrc: '/static/images/logo-longten.png',
          class: 'member-longten',
          title: '深圳市优讯龙腾科技有限公司',
          desc: '零售信息化服务',
        },
        {
          imgSrc: '/static/images/logo-uxunzhkj.png',
          class: 'member-zhihui',
          title: '深圳市优讯智慧科技有限公司',
          desc: '智能卡、RFID电子标签',
        },
        {
          imgSrc: '/static/images/logo-yxy.png',
          class: 'member-yxy',
          title: '悦乡源（山东）科技服务有限公司',
          desc: '天然乡村农产品全产业链服务',
        },
      ],
    }
  },
  methods: {
    nowSizeChange() {
      if (document.documentElement.clientWidth < 751) {
        // 是移动端，不显示内容
        return false
      } else {
        return true
      }
    },
  },
}
</script>
